import styled from 'styled-components';

export const IsLoadingCarousel = styled.div`
    height: 50vh;
`;
